exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root[data-v-c8984262]{opacity:0.4}.root.enabled[data-v-c8984262]{opacity:1}.root.enabled[data-v-c8984262]:hover{cursor:pointer}img[data-v-c8984262]{width:2rem}.fa-ban[data-v-c8984262]{color:#E94B4B}.notification-container[data-v-c8984262]{left:10px;top:-10px}\n", ""]);

